import React from "react"
import {useTranslation} from "react-i18next"

import {TReachMeta} from "../../../queries/reachEngine"
import {CardHeadline, StatRow} from "./CardStats"
import {DashboardCard} from "./DashboardCard"

export const LeadPoolCard: React.FC<{leadPool: TReachMeta["lead_pool"]}> = ({leadPool}) => {
  const {t} = useTranslation()

  return (
    <DashboardCard title={t("ReachEngine_LeadPool_Title")} subtitle={t("ReachEngine_LeadPool_Subtitle")}>
      <CardHeadline value={leadPool.total} />
      <StatRow items={[{key: "dormants", label: t("ReachEngine_LeadPool_Dormants"), value: leadPool.dormant}]} />
    </DashboardCard>
  )
}
